export default __webpack_public_path__ + "static/media/star_icon.83e7e843.svg";